import { Component, ContentChildren, EventEmitter, Input, Output, QueryList } from '@angular/core';
import { BaseViewComponent, Enum, Orientation, TabSize } from '@sb/library/base';
import { TabComponent } from '../tab.component';
import { TabGroupBodyComponent } from './body/tab-group-body.component';

@Component({
    selector: 'lib-tab-group',
    templateUrl: './tab-group.component.html',
    styleUrls: ['./tab-group.component.scss']
})
export class TabGroupComponent<T extends Enum<string>> extends BaseViewComponent {
    @ContentChildren(TabComponent, {descendants: true}) tabComponentQueryList!: QueryList<TabComponent<T>>;

    @Input() type!: Enum<any>;
    @Input() selectedTab!: T;
    @Input() stickyHeader: boolean = false;
    @Input() enableFormProtection: boolean = false;
    @Input() isInNavigation: boolean = true;
    @Input() hasBackground: boolean = false;
    @Input() size: TabSize = this.isMobile ? TabSize.Small : TabSize.Medium;
    @Input() orientation: Orientation = Orientation.Horizontal;

    @Output() selectedTabChange: EventEmitter<T> = new EventEmitter();

    SelectedTabChangeEvent(selectedTab: T): void {
        this.selectedTabChange.emit(selectedTab);
    }
}
